import { createContext } from 'react';

import { defaultWebSocketState } from '../services/websocket';

// The initial websocket context
const websocketContext = createContext(defaultWebSocketState);

export default websocketContext;
